import { makeStyles } from '@material-ui/core/styles'
import { Colors } from '@lerna-whitelabel/styles'

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    flex: 1,
    position: 'relative',
    overflow: 'hidden',
    maxHeight: '100vh',
    width: '100vw'
  },
  contentScroll: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    height: '100%',
    position: 'relative',
    overflowX: 'hidden',
    width: '100%'
  },
  contentContainer: {
    transform: 'tranlate(-100%,-100%)',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: '100%',
    width: '100%',
    fontFamily: 'Glegoo',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflowX: 'hidden',
      height: 550,
      width: 360,
      marginRight: 70,
      marginBottom: 0,
      boxShadow: '0px 0px 35px rgba(0,0,0,0.3)',
      borderRadius: '15px 15px 0 0',
      border: 'none'
    }
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '89%',
    marginLeft: '10px',
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
      marginLeft: '0',
      width: '100%',
      alignItems: 'flex-end'
    }
  },
  headerTextWrapper: {
    fontSize: '20px',
    marginLeft: '15px',
    maxWidth: '22ch',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '24ch'
    }
  },
  headerLogoWrapper: {
    fontSize: '34px',
    fontWeight: 'bold',
    color: Colors.orange[0]
  },
  headerTextParagraph: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '91%',
      fontSize: '20px'
    }
  }
}))

export default useStyles
